function PricePerCountUpdate()
{
  var mainPriceElement = document.querySelector('.product__info-wrapper .price__container .price__regular .price-item--regular');
  var originalPriceText = mainPriceElement.textContent;

  //console.log('PricePerCountUpdate originalPriceText = ' + originalPriceText);

  var allPricePerCountElements = document.querySelectorAll('.nw-pdp-pricePerCountBlock-v3-variant');

  //console.log("allPricePerCountElements.length = " + allPricePerCountElements.length);

  var priceValue = originalPriceText.replace('$','');
  
  for(var i = 0; i < allPricePerCountElements.length; i++ )
  {
    var nextElement = allPricePerCountElements[i];
    var nextSizeStandard = nextElement.getAttribute('sizeStandard');
    //console.log('nextSizeStandard = ' + nextSizeStandard);
    var pricePerValue = priceValue / nextSizeStandard;
    //console.log('pricePerValue = ' + pricePerValue);
    var pricePerValueRounded = pricePerValue.toFixed(2);
    //console.log('pricePerValueRounded = ' + pricePerValueRounded);

    nextElement.querySelector('.nw-pdp-pricePerCountBlock-v3-price').innerHTML  = "$" + pricePerValueRounded;
  }
}

function PricePerCountUpdateDosageInfoClick()
{

  var supplContainer = document.querySelector('.nw-pdp-supplement-facts-title');

  supplContainer.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
  
  //document.documentElement.scrollTop = boundingBox.top - 200;
  //document.body.scrollTop = boundingBox.top - 200; 
}